<template>
  <div class="settings-container" v-if="props.data">

    <div class="section-header section-header-2" v-if="props.data.contentModeration">
      <h3>Manage content</h3>
      <el-select v-if="props.canEdit" v-model="props.data.contentModeration.permission" default-first-option
        @change="handleContentChange">
        <el-option v-for="item in props.data.contentModeration.permissionOption" :key="item.type" :label="item.name"
          :value="item.type" />
      </el-select>
      <span v-else>{{ switchParentText(props.data.contentModeration.permission) }}</span>
    </div>

    <!-- <div class="setting-item indented" v-if="props.data.canDisableContent">
      <span>Can disable content</span>
      <div v-if="props.data.contentModeration.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.canDisableContent.permission === 100"
          @click.native="props.data.contentModeration.permission == 50 ? null :switchItem(props.data, 'canDisableContent.permission')" 
          :disabled="props.data.contentModeration.permission == 50"/>
        <span v-else>{{ switchText(props.data.canDisableContent.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.canFlagContent">
      <span>Can flag content</span>
      <div v-if="props.data.contentModeration.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.canFlagContent.permission === 100"
          @click.native="props.data.contentModeration.permission == 50 ? null :switchItem(props.data, 'canFlagContent.permission')" 
          :disabled="props.data.contentModeration.permission == 50"/>
        <span v-else>{{ switchText(props.data.canFlagContent.permission) }}</span>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { reactive, onMounted,computed } from 'vue';
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';
import Alert from '@/components/settings/SettingAlert.vue';
import Store from '@/store/index.js';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});

const { switchItem,switchText,switchParentText } = useTeamFunction();

//no access->0, can view only->50, can access->100
//+++++++++++++++++++++++++++++
const handleContentChange = (event) => {
  let val = event !== 100 ? 0 : 100;
  props.data.canDisableContent.permission = val;
  props.data.canFlagContent.permission = val;
}

// +++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++
onMounted(() => {

});
</script>

<style scoped>
.settings-container{
  height: 100%;
}
</style>